
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"45","viewBox":"0 0 38 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.449.711c.673-.885 1.93-.952 2.798-.151.867.8 1.02 2.162.347 3.05l-5.163 6.746-3.644 4.737v28.804c-.152 1.08-1.561 1.08-1.995 1.103h-.067c-.368-.021-1.56-.086-1.822-1.103V13.298l.037-.109c.041-.106.1-.199.18-.28l4.166-5.45c0-.02.02-.043.044-.065L29.449.711zM5.76.56c.867-.8 2.125-.736 2.798.151l9.328 12.197a.88.88 0 0 1 .218.389v30.728c-.066.93-1.323.93-1.887.951-.629-.021-1.822-.086-1.996-1.06V15.09l-3.646-4.737c0-.02-.02-.02-.02-.042L5.412 3.608c-.694-.887-.52-2.249.348-3.05V.56zM.77 3.934c.867-.822 2.103-.78 2.755.064l5.228 6.768c.044.02.066.065.087.108l3.318 4.283c.455.583.13 1.709-.737 2.508-.867.8-1.93.973-2.386.388l-3.623-4.67c-.02-.044-.02-.065-.043-.086L.402 6.918C-.25 6.075-.097 4.735.77 3.934zm33.689.064c.652-.844 1.887-.865 2.756-.064.868.8 1.041 2.141.39 2.962l-5.012 6.444c-.021 0-.021.022-.021.022l-3.623 4.672c-.456.583-1.519.41-2.386-.389-.867-.8-1.193-1.925-.737-2.51l3.406-4.368v-.021l5.227-6.748z","fill":"#999","fill-rule":"nonzero"}})])
          )
        }
      }
    